import { render } from "./ProductToDatasheet.vue?vue&type=template&id=1b38ac28&scoped=true&ts=true"
import script from "./ProductToDatasheet.vue?vue&type=script&lang=ts"
export * from "./ProductToDatasheet.vue?vue&type=script&lang=ts"

import "./ProductToDatasheet.vue?vue&type=style&index=0&id=1b38ac28&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Muhammad Sohail\\Herd\\yellowrockshopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b38ac28"]])

export default __exports__